import { useEffect, useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { verifySignature } from 'services/apiAuth'
import { successLogin } from '../../../redux/auth/actions'

const SignatureVerification = ({ location, history }) => {
  const signature = new URLSearchParams(location.search).get('signature')
  const dispatch = useDispatch()
  // The signature is single-use; guard against re-firing the request.
  const requestedSignature = useRef(null)

  const verifySignatureAndRedirect = useCallback(async (signatureValue) => {
    try {
      const response = await verifySignature({ signature: signatureValue })
      const { data, status } = response

      if (status === 200 && data) {
        dispatch(successLogin({ ...data }))
        history.replace({
          pathname: ROUTE_CONSTANTS.PASSWORD_REDEFINE,
        })
      } else {
        toast.error('Assinatura inválida ou expirada. Você será redirecionado ao login em breve.')
      }
    } catch (error) {
      let state
      if (error.response) {
        state = {
          error: error.response.data.detail,
          redirect: error.response.data.redirect_url,
        }
      } else {
        state = {
          error: 'Houve um problema na requisição.',
        }
      }

      history.replace({
        pathname: '/forbidden',
        state,
      })
    }
  }, [dispatch, history])

  useEffect(() => {
    if (!signature) {
      history.replace({
        pathname: '/forbidden',
        state: { error: 'Link inválido!' },
      })
      return
    }

    if (requestedSignature.current === signature) return
    requestedSignature.current = signature

    verifySignatureAndRedirect(signature).catch((error) => {
      console.error('An error occurred:', error)
    })
  }, [signature, history, verifySignatureAndRedirect])

  return null
}

export default SignatureVerification
